<nav aria-label="breadcrumb" *ngIf="breadcrumbs && breadcrumbs.length > 0">
    <ol class="breadcrumb">
        <ng-container *ngFor="let breadcrumb of breadcrumbs; last as isLast">
            <li class="breadcrumb-item" [ngClass]="{'active': isLast}">
                <a *ngIf="breadcrumb.isLink" [routerLink]="breadcrumb.router"
                   [attr.data-Identifier]="getDataIdentifier(breadcrumb)">
                    {{ breadcrumb.label }}
                </a>
                <span *ngIf="!breadcrumb.isLink"
                      [attr.data-Identifier]="getDataIdentifier(breadcrumb)">
                    {{ breadcrumb.label }}
                </span>
            </li>
        </ng-container>
    </ol>
</nav>
